import { getIsServerEnv } from './get-is-server-env';

/**
 * @returns {string | undefined} the value of a runtime env variable depending on the app current execution environment
 * (`process.env` for the server/Node or `window.env` for the client/Browser)
 */
export function getRuntimePublicEnvVariable<T extends keyof Runtime.PublicEnvVariables>(name: T) {
  if (getIsServerEnv()) {
    return process.env[name];
  }

  if (typeof window.env === 'object') {
    return window.env[name];
  }

  throw new Error('Invalid "env" object, check "getRuntimePublicEnvVariable" function');
}
